import React from "react";
import { interviews } from "../../assets/text/interview";

const MainMobileScreen = ({ handleImageLink, handleMobileNavigation }) => {
  const data = interviews;
  return (
    <div className="main-responsive-english">
      <div className="main-responsive-english-instructions">
        KINDLY REFER TO OUR DESKTOP VERSION TO FULLY EXPERIENCE THE TOOL WE HAVE
        CURATED
      </div>
      <div className="main-responsive-english-video">
        <span className="main-responsive-english-video-text">A QUICK DEMO</span>
        <div className="main-responsive-english-video-div">
          <video style={{ width: "100%" }} controls>
            <source src="/vid/bilingualwebsite-tutorial.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
      <div className="main-responsive-english-articles">
        <span className="main-responsive-english-articles-more">for more</span>
        {data.map((article) => (
          <div
            key={article.content.english.date}
            className="main-responsive-english-articles-article"
          >
            <div className="main-responsive-english-articles-article-text">
              <div
                className="main-responsive-english-articles-article-text-title"
                onClick={() => {
                  handleImageLink(true, article);
                  handleMobileNavigation("interview");
                }}
              >
                {article.content.english.title}
              </div>
              <div className="main-responsive-english-articles-article-text-date">
                {`${article.content.english.date} /`}
                <span style={{ textDecoration: "underline" }}>
                  &nbsp;{article.content.english.category}
                </span>
              </div>
            </div>
            <div style={{ width: "35%" }}>
              <img
                className="main-responsive-english-articles-article-image"
                src={`images/${article.imageSquare}`}
                alt="Article"
              ></img>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MainMobileScreen;
